"use client";

import Link from "next/link";
import { Marquee, TextAnimation } from "politicamente-informados-ds";

interface IAttrs {
  text: string;
  backgroundColor: string;
  color?: string;
  direction?: string;
  repeatLines: number;
  repeatContent: number;
  rotateDeg?: number | undefined;
  duration: number;
  className?: string | undefined;
}

export type IBlockMarquee = {
  attrs: IAttrs;
};

export default function BlockMarqueeTopic({
  attrs,
}: {
  attrs: Record<string, any>;
}) {
  const {
    className,
    repeatLines = 1,
    repeatContent = 5,
    text = "",
    color,
    backgroundColor,
    duration = 15,
    direction = "left",
    rotateDeg = 0,
    href,
  } = attrs || {};

  const url =
    href?.url?.replace(
      process.env.NEXT_PUBLIC_WP_URL as string,
      process.env.NEXT_PUBLIC_FE_URL as string
    ) || "";
  const newTab = href?.newTab;

  const linkTarget = newTab ? "_blank" : "_parent";

  return (
    <Link href={url} target={linkTarget}>
      <Marquee
        color={color}
        backgroundColor={backgroundColor}
        duration={duration}
        direction={direction}
        rotateDeg={rotateDeg}
        className={className}
      >
        <TextAnimation
          tag={"div"}
          repeatContent={repeatContent}
          repeatLines={repeatLines}
          className="d-flex align-items-center h2 fw-bold"
        >
          <span className="font-outline-white" style={{ margin: "0 40px" }}>
            {text}
          </span>

          <span className="text-white" style={{ margin: "30px 40px" }}>
            {text}
          </span>
        </TextAnimation>
      </Marquee>
    </Link>
  );
}
